import { Nav, Offcanvas } from "react-bootstrap";
import authUserIcon from "../../../../images/icons/topNavBar/menu/authUser.svg";
import accountIcon from "../../../../images/icons/topNavBar/menuItems/account.svg";
import helpIcon from "../../../../images/icons/topNavBar/menuItems/help.svg";
import signOutIcon from "../../../../images/icons/topNavBar/menuItems/signOut.svg";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../app/store";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { logoutThunk } from "../../../../pages/layoutes/authLayout/authThunks";
import { useClearingOrder } from "../../../../hooks/useClearingOrder";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { routes } from "../../../../app/routes/routes";

interface Props {
    userEmail: string;
    onAction?: () => void;
}

const AuthUserDropDown = ({ userEmail, onAction }: Props) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [clearOrder] = useClearingOrder();
    const isMobile = useMediaQuery("(max-width: 575px)");
    const [showPanel, setShowPanel] = useState(false);

    const handleNavigate = useCallback(
        (path: string) => {
            setShowPanel(false);
            onAction?.();
            navigate(path);
        },
        [navigate, onAction]
    );

    const handleSignOut = useCallback(async () => {
        setShowPanel(false);
        await dispatch(logoutThunk());
        clearOrder();
        onAction?.();
    }, [clearOrder, dispatch, onAction]);

    const handleClose = () => setShowPanel(false);

    return (
        <>
            <Nav.Item>
                <Nav.Link onClick={() => setShowPanel(true)} className="d-flex align-items-center gap-2">
                    <img src={authUserIcon} alt={t("navbar.topNavBar.user")} />
                    {isMobile && <span>{t("navbar.topNavBar.user")}</span>}
                </Nav.Link>
            </Nav.Item>

            <Offcanvas
                show={showPanel}
                onHide={handleClose}
                placement={isMobile ? "bottom" : "end"}
                className="top-bar-offcanvas"
                data-bs-theme="dark"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{t("navbar.topNavBar.user")}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="top-bar-offcanvas__list">
                        <Nav.Item className="top-bar-offcanvas__info">
                            <p>{t("navbar.topNavBar.authUser.registeredAs")}</p>
                            <p>{userEmail}</p>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={() => handleNavigate(routes.profile.path)} className="d-flex align-items-center gap-2">
                                <img src={accountIcon} />
                                <span>{t("navbar.topNavBar.authUser.account")}</span>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={() => handleNavigate(routes.support.path)} className="d-flex align-items-center gap-2">
                                <img src={helpIcon} />
                                <span>{t("navbar.topNavBar.authUser.help")}</span>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={handleSignOut} className="d-flex align-items-center gap-2">
                                <img src={signOutIcon} />
                                <span>{t("navbar.topNavBar.authUser.signOut")}</span>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AuthUserDropDown;
